import config from 'config';

import _ from 'lodash';

const LOAD = 'football/league-table/LOAD';
const LOAD_SUCCESS = 'football/league-table/LOAD_SUCCESS';
const LOAD_FAIL = 'football/league-table/LOAD_FAIL';

const initialState = {
};

export default function reducer(state = initialState, action = {}) {
  const seasonKey = action.season || 'current';
  const competition = action.competition;
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        [competition]: {
          ...state[competition],
          [seasonKey]: {
            ...(state[competition] || {})[seasonKey],
            loading: true
          }
        }
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        [competition]: {
          ...state[competition],
          [seasonKey]: {
            loading: false,
            loaded: true,
            tables: action.result.tables
          }
        }
      };
    case LOAD_FAIL:
      return {
        ...state,
        [competition]: {
          ...state[competition],
          [seasonKey]: {
            ...(state[competition] || {})[seasonKey],
            loading: false,
            loaded: false,
            error: action.error
          }
        }
      };
    default:
      return state;
  }
}

function getTableForMatchId(globalState, matchId) {
  // get the competition and season from the referenced match, which should already be in state
  const competitionId = getCompetitionIdFromMatchId(globalState, matchId);

  const seasonKey = 'current';
  return _.get(globalState.football.leagueTable, [competitionId, seasonKey], {});
}

function getMatchFromMatchId(globalState, matchId) {
  return _.get(globalState.football.match, [matchId, 'match'], null);
}

function getCompetitionIdFromMatchId(globalState, matchId) {
  return _.get(
    getMatchFromMatchId(globalState, matchId), 
    "match_detail.competition.competition_reference.id", 
    null
  );
}

export function isLoadingByMatch(globalState, matchId) {
  return getTableForMatchId(globalState, matchId).loading;
}

export function hasMatchCompetition(globalState, matchId) {
  return getCompetitionIdFromMatchId(globalState, matchId) !== null;
}

export function loadByMatch(globalState, matchId) {
  // get the competition from the referenced match, which should already be in state
  const competition = getCompetitionIdFromMatchId(globalState, matchId);
  if (!competition) {
    return false;
  }

  return {
    competition,
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: (client) => client.get(config.api.football.leagueTable, { params: {competition} })
  };
}

export function isLoadingByCompetition(globalState, competition = "default") {
  return _.get(globalState.football.leagueTable, [competition, "current"], {}).loading;
}

export function loadByCompetition(competition = "default", season = "current") {
  let params;

  if (competition == "default") {
    params = {default: true};
  }
  else if (season == "current") {
    params = {competition};
  }
  else {
    params = {competition, season};
  }

  return {
    competition,
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: (client) => client.get(config.api.football.leagueTable, { params })
  };
}

export function getByCompetition(globalState, competition = "default", season = "current") {
  const {
    [competition]: {
      [season]: {
        tables = []
      } = {}
    } = {}
  } =  globalState.football.leagueTable;

  return tables;
}

export const get = getTableForMatchId;



// WEBPACK FOOTER //
// ./modules/Football/reducers/leagueTable.js